"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberCommonUtils = void 0;
const decimal_js_1 = __importDefault(require("decimal.js"));
const utils_1 = require("../utils");
const SafeDecimal_1 = require("./SafeDecimal");
const DECIMAL_100 = new SafeDecimal_1.SafeDecimal(100);
var NumberType;
(function (NumberType) {
    NumberType[NumberType["trillion"] = 1000000000000] = "trillion";
    NumberType[NumberType["billion"] = 1000000000] = "billion";
    NumberType[NumberType["million_100"] = 100000000] = "million_100";
    NumberType[NumberType["million"] = 1000000] = "million";
    NumberType[NumberType["thousand_10"] = 10000] = "thousand_10";
    NumberType[NumberType["thousand"] = 1000] = "thousand";
})(NumberType || (NumberType = {}));
function isValid(value) {
    return value !== undefined && value !== null;
}
exports.NumberCommonUtils = {
    toDecimalPlaces(val, decimalPlaces, defaultValue = 0, rounding = decimal_js_1.default.ROUND_FLOOR) {
        if (!val) {
            try {
                return new decimal_js_1.default(defaultValue);
            }
            catch (error) {
                return new decimal_js_1.default(0);
            }
        }
        try {
            return new SafeDecimal_1.SafeDecimal(val).toDecimalPlaces(new SafeDecimal_1.SafeDecimal(decimalPlaces).toNumber(), rounding);
        }
        catch (error) {
            return new SafeDecimal_1.SafeDecimal(defaultValue);
        }
    },
    str2number(str, defaultValue = 0) {
        const num = parseFloat(str);
        if (isNaN(num)) {
            return defaultValue;
        }
        return num;
    },
    toNormalPrice(val, defaultValue = 0, rounding = decimal_js_1.default.ROUND_FLOOR) {
        if (!val) {
            return new SafeDecimal_1.SafeDecimal(defaultValue).toString();
        }
        try {
            const decimalValue = new SafeDecimal_1.SafeDecimal(val);
            /**
             * 数字精确度：>=100时精确到小数点后2位，<100 and >=1时精确到小数点后4位，<1时保留4位有效数字。
             */
            if (decimalValue.greaterThanOrEqualTo(100)) {
                return decimalValue.toDecimalPlaces(2, rounding).toString();
            }
            else if (decimalValue.greaterThanOrEqualTo(1)) {
                return decimalValue.toDecimalPlaces(4, rounding).toString();
            }
            else {
                const decimalPlacesValue = decimalValue.decimalPlaces();
                const precisionValue = decimalValue.precision();
                if (decimalPlacesValue - precisionValue > Math.abs(utils_1.DecimalExpNeg)) {
                    return "0";
                }
                return decimalValue.toSignificantDigits(4, rounding).toFixed();
            }
        }
        catch (e) {
            return "0";
        }
    },
    formatterDecimal(val, decimal = 2, rounding = decimal_js_1.default.ROUND_FLOOR) {
        return this.toDecimalPlaces(val, decimal, 0, rounding);
    },
    formatterDecimalToStr(val, decimal = 2, rounding = decimal_js_1.default.ROUND_FLOOR) {
        return this.toDecimalPlaces(val, decimal, 0, rounding).toString();
    },
    toFix(val, decimal = 0, rounding = decimal_js_1.default.ROUND_FLOOR) {
        try {
            const decimalValue = new SafeDecimal_1.SafeDecimal(val);
            return decimalValue.toFixed(new SafeDecimal_1.SafeDecimal(decimal).toNumber(), rounding);
        }
        catch (e) {
            return new SafeDecimal_1.SafeDecimal(0).toFixed(new SafeDecimal_1.SafeDecimal(decimal).toNumber(), rounding);
        }
    },
    toBalance(value, rounding = decimal_js_1.default.ROUND_FLOOR) {
        return this.formatterDecimal(value, 8, rounding).toString();
    },
    toPercent(val, addPrefix = true, addSuffix = true, precision = 2) {
        let prefix = "";
        let result = "0";
        try {
            const decimal = new SafeDecimal_1.SafeDecimal(val ? val : 0);
            if (addPrefix && decimal.gte(0)) {
                // >=0
                prefix = "+";
            }
            result = decimal.toFixed(new SafeDecimal_1.SafeDecimal(precision).toNumber(), SafeDecimal_1.SafeDecimal.ROUND_FLOOR);
        }
        catch (e) {
            if (addPrefix) {
                prefix = "+";
            }
        }
        return `${prefix}${result}${addSuffix ? "%" : ""}`;
    },
    toFiatPrice(val) {
        try {
            const decimalValue = new SafeDecimal_1.SafeDecimal(val);
            /**
             * 数字精确度：>=100时精确到小数点后2位，<100 and >=1时精确到小数点后4位，<1时保留4位有效数字。
             */
            if (decimalValue.greaterThanOrEqualTo(1)) {
                return decimalValue.toDecimalPlaces(2, decimal_js_1.default.ROUND_FLOOR).toString();
            }
            else if (decimalValue.lessThan(0.00000001)) {
                return "0";
            }
            else {
                return decimalValue.toSignificantDigits(2, decimal_js_1.default.ROUND_FLOOR).toFixed();
            }
        }
        catch (e) {
            return "0";
        }
    },
    getValidNumberString(value) {
        value = value.trim();
        if (value.length === 0 || value === "0") {
            return value;
        }
        const matchValue = value.match("^(([0-9]+\\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\\.[0-9]+)|([0-9]*[1-9][0-9]*))$");
        if (matchValue !== null) {
            return matchValue[0];
        }
        return matchValue;
    },
    // 前方补零
    complementDigit(value, n) {
        if (`${value}`.length >= n) {
            return `${value}`;
        }
        return `${Array(n).join("0")}${value}`.slice(-n);
    },
    handleDivide(dividend, divisor) {
        const x = new SafeDecimal_1.SafeDecimal(dividend);
        const y = new SafeDecimal_1.SafeDecimal(divisor);
        return Number(x.dividedBy(y).toPrecision());
    },
    minus(minuend, minusValue) {
        return new SafeDecimal_1.SafeDecimal(minuend).minus(new SafeDecimal_1.SafeDecimal(minusValue)).toNumber();
    },
    getPrecision(value, defaultPrecision = 0) {
        if (!isValid(value)) {
            return defaultPrecision;
        }
        const valueString = value.toString();
        const snIndex = valueString.indexOf("e-");
        if (snIndex >= 0) {
            const snPrecision = parseInt(valueString.slice(valueString.indexOf("e-") + 2), 10);
            let pointPrecision = 0;
            const pointIndex = valueString.indexOf(".");
            if (pointIndex >= 0) {
                pointPrecision = snIndex - pointIndex - 1;
            }
            return snPrecision + pointPrecision;
        }
        let precision = defaultPrecision;
        if (valueString.indexOf(".") >= 0) {
            precision = valueString.length - valueString.indexOf(".") - 1;
        }
        return precision;
    },
    effectiveDecimal(value, decimal = 2, rounding = decimal_js_1.default.ROUND_FLOOR) {
        return this.toDecimalPlaces(value, decimal, 0, rounding).toString();
    },
    _inner_EffectiveDecimal(val, decimal = 2, rounding = decimal_js_1.default.ROUND_FLOOR) {
        return this.toDecimalPlaces(val, decimal, 0, rounding);
    },
    getFormatValueString(num, precisionNum) {
        try {
            const decimal = new SafeDecimal_1.SafeDecimal(num);
            const result = this.formatterDecimalToStr(decimal, precisionNum);
            if (decimal.greaterThan(1)) {
                return result;
            }
            return this.formatterDecimalToStr(decimal.toPrecision(precisionNum), precisionNum);
        }
        catch (e) {
            return "0";
        }
    },
    getDigitsNumber(a) {
        let x = a;
        let count = 0;
        while (x >= 1) {
            x /= 10;
            count++;
        }
        return count;
    },
    toShortString(locale, value, rounding = decimal_js_1.default.ROUND_FLOOR) {
        try {
            if (value) {
                const valueDecimal = new decimal_js_1.default(value);
                const isCN = locale === "zh-CN";
                if (isCN || locale === "zh-TW") {
                    let _num = "";
                    let _suffix = "";
                    if (valueDecimal.greaterThanOrEqualTo(NumberType.trillion)) {
                        _num = new SafeDecimal_1.SafeDecimal(valueDecimal).div(NumberType.trillion).toFixed(4, rounding);
                        _suffix = isCN ? "万亿" : "萬億";
                    }
                    else if (valueDecimal.greaterThanOrEqualTo(NumberType.million_100)) {
                        _num = new SafeDecimal_1.SafeDecimal(valueDecimal).div(NumberType.million_100).toFixed(2, rounding);
                        _suffix = isCN ? "亿" : "億";
                    }
                    else if (valueDecimal.greaterThanOrEqualTo(NumberType.thousand_10)) {
                        _num = new SafeDecimal_1.SafeDecimal(valueDecimal).div(NumberType.thousand_10).toFixed(2, rounding);
                        _suffix = isCN ? "万" : "萬";
                    }
                    else {
                        //2
                        _num = exports.NumberCommonUtils.toNormalPrice(valueDecimal);
                    }
                    return _num + _suffix;
                }
                else {
                    let _numType = 0;
                    let _suffix = "";
                    if (valueDecimal.greaterThanOrEqualTo(NumberType.trillion)) {
                        _numType = NumberType.trillion;
                        _suffix = "T";
                    }
                    else if (valueDecimal.greaterThanOrEqualTo(NumberType.billion)) {
                        _numType = NumberType.billion;
                        _suffix = "B";
                    }
                    else if (valueDecimal.greaterThanOrEqualTo(NumberType.million)) {
                        _numType = NumberType.million;
                        _suffix = "M";
                    }
                    else if (valueDecimal.greaterThanOrEqualTo(NumberType.thousand)) {
                        _numType = NumberType.thousand;
                        _suffix = "K";
                    }
                    else {
                        //加到后缀
                        _suffix = exports.NumberCommonUtils.toNormalPrice(valueDecimal);
                    }
                    return _numType > 0 ? new SafeDecimal_1.SafeDecimal(valueDecimal).div(_numType).toFixed(2, rounding) + _suffix : _suffix;
                }
            }
            else {
                return "0";
            }
        }
        catch (e) {
            return "0";
        }
    },
};
